<!--
  ~ ls-elements
  ~ Copyright (C) 2024 Libriciel SCOP
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published by
  ~ the Free Software Foundation, either version 3 of the License, or
  ~ (at your option) any later version.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program. If not, see <http://www.gnu.org/licenses/>.
  -->

<ng-template #paginate>
  @if((_paginate && _data.length > _pagesize) || !fulldata) {
    <nav role="navigation" aria-label="Pagination" class="mt-5 position-relative d-none d-md-block">
      <div class="d-none d-md-inline-block browser-paginate">
        {{ ((_page - 1) * _pagesize) + 1 }}-{{ (_page * _pagesize) | min:(fulldata ? _data.length : total) }}
        sur {{ fulldata ? _data.length : total }}
        <button type="button" class="d-inline-flex justify-content-center"
           [disabled]="_page <= 1"
           (click)="previousPage()">
          <fa-icon icon="chevron-left" size="lg"></fa-icon>
          <span class="visually-hidden-focusable">
            Page précédente
          </span>
        </button>
        <button type="button" class="d-inline-flex justify-content-center"
           [disabled]="!(_page < (fulldata ? _data.length : total) / _pagesize)"
           (click)="nextPage()">
          <fa-icon icon="chevron-right" size="lg"></fa-icon>
          <span class="visually-hidden-focusable">
            Page suivante
          </span>
        </button>
      </div>
    </nav>
    <nav role="navigation" aria-label="Pagination" class="d-flex d-md-none justify-content-between">
      <button type="button" class="mobile-nav align-right"
         [disabled]="_page <= 1"
         (click)="previousPage()">
        <fa-icon icon="chevron-left" size="lg"/>
        <span class="visually-hidden-focusable">
          Page précédente
        </span>
      </button>
      <span>{{ ((_page - 1) * _pagesize) + 1 }}-{{ (_page * _pagesize) | min:(fulldata ? _data.length : total) }}
        sur {{ fulldata ? _data.length : total }}</span>
      <button type="button" class="mobile-nav"
         [disabled]="!(_page < (fulldata ? _data.length : total) / _pagesize)"
         (click)="nextPage()">
        <fa-icon icon="chevron-right" size="lg"/>
        <span class="visually-hidden-focusable">
          Page suivante
        </span>
      </button>
    </nav>
  }
</ng-template>

@if(!_paginatedData) {
  <div class="pt-5">
    <ls-spinner></ls-spinner>
  </div>
} @else if (_paginatedData.length === 0) {
  <p class="text-light-grey">Aucun résultat</p>
} @else {
  @if(paginationTop) {
    <ng-container [ngTemplateOutlet]="paginate"></ng-container>
  }

  <table class="table table-striped ls-table-responsive mt-3 mt-md-0" aria-describedby="">
    <thead>
    <tr>
      @for(h of headers; track h) {
        <th scope="col" [class]="h.class" [title]="h.sortable ? 'Trier avec la propriété ' + h.label : ''" [attr.role]="h.sortable ? 'button': ''" [attr.aria-sort]="_currentSort === h.property ? _sortAsc ? 'ascending' : 'descending' : 'none'" [tabIndex]="h.sortable ? '0': '-1'" (keydown.enter)="sort(h)" (click)="sort(h)" [class.text-center]="h.center" [class.sortable]="h.sortable">
          @if(h.sortable && _currentSort === h.property) {
            @if (h.sortIcon === 'numeric') {
              <fa-icon [icon]="_sortAsc ? 'arrow-up' : 'arrow-down'"></fa-icon>
            } @else {
              <fa-icon [icon]="_sortAsc ? 'sort-alpha-down' : 'sort-alpha-down-alt'"></fa-icon>
            }
          }
          {{ h.label }}
        </th>
      }
      @if(actions.length > 0) {
        <th scope="col" class="action">Actions</th>
      }
    </tr>
    </thead>
    <tbody class="position-relative">
      @if(loadingData) {
        <ls-spinner class="loadingData"></ls-spinner>
      }
      @for(d of _paginatedData; track (track ? d[track] : d)) {
        <tr [ngClass]="rowCustomClass ? rowCustomClass(d) : ''" [ngbTooltip]="rowTooltip ? rowTooltip(d) : '' " container="body">
          <ng-template [ngTemplateOutlet]="templateRef" [ngTemplateOutletContext]="{$implicit: d}"></ng-template>
          @if(actions.length > 0) {
            <td class="action d-table-cell">
              <div class="d-flex justify-content-center h-100">
                @for(a of actions; track a) {
                  @if(!a.condition || a.condition(d)) {
                    <button [title]="a.tooltip"
                            role="button"
                            [attr.aria-label]="a.tooltip"
                            [ngClass]="a.cssClass"
                            [ngbTooltip]="a.tooltip"
                            (click)="a.eventHandler(d)">
                      <fa-icon icon="{{a.icon}}" size="lg"></fa-icon>
                    </button>
                  }
                }
              </div>
            </td>
          }
        </tr>
      }
    </tbody>
  </table>

  @if(paginationBottom) {
    <ng-container [ngTemplateOutlet]="paginate"></ng-container>
  }
}
